import { DEFAULT_LANGUAGE } from '../constants';

export default () => (
  navigator.language || DEFAULT_LANGUAGE
).split('-')[0];
